import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const COLLECTION = 'budgetSettings';
const DOCUMENT_ID = 'global';

export class BudgetService {
    static async getBudgets() {
        try {
            const ref = doc(db, COLLECTION, DOCUMENT_ID);
            const snapshot = await getDoc(ref);

            if (!snapshot.exists()) {
                return null;
            }

            const data = snapshot.data();
            return data.budgets ?? null;
        } catch (error) {
            console.error("Error getting budget settings:", error);
            return null;
        }
    }

    static async saveBudgets(budgets) {
        const ref = doc(db, COLLECTION, DOCUMENT_ID);
        await setDoc(
            ref,
            {
                budgets,
                updatedAt: serverTimestamp(),
            },
            { merge: true }
        );
    }
}
